"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantId = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.MerchantId = {
    priority: Number.MAX_VALUE,
    label: 'fields.payload.merchant_id.label',
    fallbackLabel: 'Merchant id',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => true,
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return false;
}
